export default __webpack_public_path__ + "952a911614b5d977da306fafbd814c99.pdf";